// services/ClinicalCaseService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getClinicalCases(params = {}) {
    return api.get(ENDPOINTS.CLINICAL_CASES.BASE, { params });
}
export function getClinicalCaseById(id) {
    return api.get(ENDPOINTS.CLINICAL_CASES.BY_ID(id));
}
export function createClinicalCase(payload) {
    return api.post(ENDPOINTS.CLINICAL_CASES.BASE, payload);
}
export function updateClinicalCase(id, payload) {
    return api.patch(ENDPOINTS.CLINICAL_CASES.BY_ID(id), payload);
}
export function deleteClinicalCase(id) {
    return api.delete(ENDPOINTS.CLINICAL_CASES.BY_ID(id));
}
export function restoreClinicalCase(id) {
    return api.post(`${ENDPOINTS.CLINICAL_CASES.BY_ID(id)}/restore`);
}

// IMAGE du cas clinique (multipart, champ "image") : même règles que pour les questions
export function uploadClinicalCaseImage(id, file) {
    const formData = new FormData();
    formData.append("image", file);
    return api.post(`${ENDPOINTS.CLINICAL_CASES.BY_ID(id)}/image`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}
export function deleteClinicalCaseImage(id) {
    return api.delete(`${ENDPOINTS.CLINICAL_CASES.BY_ID(id)}/image`);
}

// AFFECTATION des questions : liste ORDONNÉE des identifiants (l'ordre devient l'ordre d'affichage)
export function setClinicalCaseQuestions(id, questionIds) {
    return api.put(`${ENDPOINTS.CLINICAL_CASES.BY_ID(id)}/questions`, { question_ids: questionIds });
}